import React, { useEffect, useRef, useState } from 'react'
import { Table, message, ConfigProvider, Button, Pagination, Row, Col} from 'antd'
import globalStyles from "../common/global-styles/idatacourse-table.module.less"
import { sendHttpPostRequest } from '../../api/http-request'
import courseMainStyles from './course-main.module.less'
import zhCN from 'antd/lib/locale/zh_CN'
import kejianEmpty from '../../static/image/empty/queshengye-kejian.png'

import exerciseStyles from "../exercise/exercise.module.less";

import slidesStyles from './slides/course-main-teacher-slides.module.less'
import Cookies from 'js-cookie'
import courseTeacherMenuStyles from "./menu/course-main-teacher-menu.module.less";
import { ArrowRightOutlined, LockOutlined } from '@ant-design/icons';

const typeMap = new Map([[1, '实操题'], [2, '单选题'], [3, '多选题'],[4, '排序题'], [5, '主观题']]);
const difficultyMap = new Map([[1, '容易'], [2, '中等'], [3, '困难']]);


export interface Props {
  course_id: any,                
  is_pay: any,
  is_overdue: any
}
/** 平台课程配套习题页*/
export const PlatformCourseExercises: React.FC<Props> = (props) => {
  const { course_id, is_pay, is_overdue} = props
  const [exercises, setExercises] = useState([] as any[]) //课程的习题
  const [totalSum, setTotalSum] = useState(0) //课程的总习题数量
  const page = useRef(1)
  const pagesize = useRef(9)

  const queryExercises = () => {
    sendHttpPostRequest(
      'course/api/user_query_platform_course_exercises',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: course_id,
        page: page.current,
        pagesize: pagesize.current
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 没登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
        } else if (response.code == -501) {
          // 没权限
          message.error('权限不足')
        } else if (response.is_ok) {
          setExercises(response.exercise_list)
          setTotalSum(response.total_sum)
        } else {
          message.error(response.message)
        }
      }
    )
  }


  useEffect(() => {
    queryExercises()
  }, [])


  // 点了预览按钮
  const onLookOverBtnClick = (exerciseId: string, event: any) => {
      window.open(`/exercise-preview?exercise_id=${exerciseId}`);
  }
    // 渲染类型
    const renderType = (text: any, record: any) => (
      <div>{typeMap.get(parseInt(text))}</div>
  )

  // 渲染难易程度
  const renderDifficulty = (text: any, record: any) => (
      <div>{difficultyMap.get(parseInt(text))}</div>
  )


      const getExeTypeLabeStyle = (type:number)=> {
        if(type == 1) {
            return {fontSize:12,color:'#ea580c', background:'rgb(255 247 237)', borderRadius:999, padding:'4px 10px'}
        }else if(type == 2) {
            return {fontSize:12,color:'rgb(37 99 235)', background:'rgb(239 246 255)', borderRadius:999, padding:'4px 10px'}
        }else if(type == 3) {
            return {fontSize:12,color:'#9333EA', background:'#FAF5FF', borderRadius:999, padding:'4px 10px'}
        }else if(type == 4) {
            return {fontSize:12,color:'#db2777', background:'#fdf2f8', borderRadius:999, padding:'4px 10px'}
        
        }else {
            return {fontSize:12,color:'#4fe6e5', background:'#eef2ff', borderRadius:999, padding:'4px 10px'}
        }
    }

    const getTypeName = (type:number)=> {
        if(type == 1) {
            return "实操题"
        }else if(type == 2) {
            return "单选题"
        }else if(type == 3) {
            return "多选题"
        }else if(type == 4) {
            return "排序题"
        
        }else {
            return "主观题"
        }
    }


    const getExeDifficultLabeStyle = (type:number)=> {
        if(type == 1) {
            return {fontSize:12,color:'#16A34A', background:'#F0FDF4', borderRadius:999, padding:'4px 10px'}
        }else if(type == 2) {
            return {fontSize:12,color:'#CA8A04', background:'#FEFCE8', borderRadius:999, padding:'4px 10px'}
        }else if(type == 3) {
            return {fontSize:12,color:'#DC2626', background:'#FEF2F2', borderRadius:999, padding:'4px 10px'}
        }
    }

    const getDifficultName = (type:number)=> {
        if(type == 1) {
            return "容易"
        }else if(type == 2) {
            return "中等"
        }else if(type == 3) {
            return "困难"
        }
    }

    
  // 渲染操作
  const renderActions = (text: any, record: any) => {
    return (
      <div>
          { is_overdue == false && is_pay == true ? <Button
            onClick={onLookOverBtnClick.bind(this, record.id)}
            className={slidesStyles.actionBtn}
            style={{ borderRadius: 20, marginRight: 5 }}
            size="small"
            type="link"
          >
            {' '}
            预览{' '}
          </Button> : <LockOutlined  className={courseTeacherMenuStyles.iconbuttons}/>  }
      </div>
    )
  }


    //页码和页数发生了变化
    const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
      page.current = newPage ? newPage : 1;
      if (newPageSize) {
          pagesize.current = newPageSize;
      }
      queryExercises();
  }


  const exerciseCols: any = [
    {
      title: '序号',
      dataIndex: 'index_number',
      key: 'index_number',
      align: 'center',
      width: 80,
      //render: (text, record, index) => slides.indexOf(record) + 1,
    },
    {
      title: '题目名称',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
      align: 'left',
      width: "auto",
    },
    {
      title: '题型',
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      width: 100,
      ellipsis: true,
      render: renderType,
    },
   
    {
      title: '难度',
      dataIndex: 'difficulty',
      key: 'difficulty',
      align: 'center',
      ellipsis: true,
      width: 100,
      render: renderDifficulty,
    },
    {
      title: '知识点',
      dataIndex: 'knowcell',
      key: 'knowcell',
      ellipsis: true,
      align: 'left',
      width: 300,
    },
    
    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions',
      width: 120,
      ellipsis: true,
      align: 'center',
      render: renderActions,
    },
  ]


  return (
    <div >
      <div >
        {exercises.length != 0 && (<>
            <Row gutter={[24, 24]} wrap={true} justify="start">
                {exercises?.map((exercise) => {
                    return (
                        <Col key={exercise.id} span={8}>
                            <div
                                className={exerciseStyles.exeCard}
                                style={{textAlign:'left'}}
                                    
                            >

                                <Row align="middle" justify="start" gutter={[12,12]} style={{margin:'0 0 12px'}}>
                                    <Col span={12} style={{textAlign:"left"}}>
                                        <div >
                                            <span style={getExeTypeLabeStyle(exercise?.type)} >{getTypeName(exercise?.type)}</span>
                                        </div>  
                                    </Col>
                                    <Col span={12} style={{textAlign:"right"}} >
                                        <div >
                                            <span style={getExeDifficultLabeStyle(exercise?.difficulty)} >{getDifficultName(exercise?.difficulty)}</span>
                                        </div>  
                                    </Col>

                                </Row>

                                <div className={exerciseStyles.cardTitle}>
                                    {exercise?.title}
                                </div>

                                <div className={exerciseStyles.cardDescription}>
                                        {exercise.steps}
                                </div>

                                <Row align="middle" justify="start" gutter={[12,12]} style={{margin:'0 0 12px'}}>
                                    <Col span={12} style={{textAlign:"left"}}>
                                        <div className={exerciseStyles.exeCardTime}
                                        style={{whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>
                                            知识点: {exercise?.knowcell}
                                        </div>  
                                    </Col>
                                    <Col span={12} style={{textAlign:"right"}} >
                                        <div  style={{textAlign:'right'}}  > { is_overdue == false && is_pay == true ? <span className={exerciseStyles.cardLookBtn} onClick={onLookOverBtnClick.bind(this, exercise?.id)}  > 查看详情 <ArrowRightOutlined /> </span> : <LockOutlined  className={courseTeacherMenuStyles.iconbuttons}/>}</div> 
                                    </Col>

                                </Row>
                                
                            </div>
                        </Col>
                    )
                })}

                
            </Row>

            <ConfigProvider locale={zhCN}>
            <div style={{marginTop:16,marginBottom:16}} className={"css.pagination"} >
                <Pagination
                    defaultCurrent={1}
                    total={totalSum}
                    defaultPageSize={9}
                    hideOnSinglePage={true}
                    current={page.current}
                    onChange={onPageChange}
                    showQuickJumper={false}
                    showSizeChanger={false}
                    showTotal={total => `共 ${total} 习题`}
                    //pageSizeOptions={["10","20","50","100"]}
                />
            </div>
            </ConfigProvider>
          </>
        )}

        {exercises.length == 0 && (
          <div style={{ textAlign: 'center', paddingTop: 20 }}>
            <img src={kejianEmpty} width={120} height={120} />
            <div style={{ color: '#999', marginTop: 10 }}>
              本课程还没有添加习题~
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default PlatformCourseExercises
